import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AlertModule,
  LoadingSpinnerModule,
} from '@proximus/ng-common-components';
import { TranslationModule } from '@proximus/ng-common';

import { PublicWifiRoutingModule } from './public-wifi-routing.module';
import { PublicWifiDetailsComponent } from './public-wifi-details/public-wifi-details.component';
import { PublicWifiSelectorComponent } from './public-wifi-selector/public-wifi-selector.component';
import { PublicWifiAccountListComponent } from './public-wifi-account-list/public-wifi-account-list.component';
import { PublicWifiAccountManageComponent } from './public-wifi-account-manage/public-wifi-account-manage.component';
import { PublicWifiAccountCreateComponent } from './public-wifi-account-create/public-wifi-account-create.component';
import { PublicWifiAccountsComponent } from './public-wifi-accounts/public-wifi-accounts.component';
import { EffectsModule } from '@ngrx/effects';
import { PublicWifiEffects } from './store/effects/public-wifi.effects';
import { AuB2B2EOnlyGuard } from '../guards/au-b2b2e-only.guard';
import { PublicWifiService } from './services/public-wifi.service';
import { FormsModule } from '@angular/forms';
import { PublicWifiAccountFilterPipe } from './pipe/public-wifi-account-filter-pipe';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    PublicWifiDetailsComponent,
    PublicWifiSelectorComponent,
    PublicWifiAccountListComponent,
    PublicWifiAccountManageComponent,
    PublicWifiAccountCreateComponent,
    PublicWifiAccountsComponent,
    PublicWifiAccountFilterPipe,
  ],
  imports: [
    CommonModule,
    TranslationModule,
    PublicWifiRoutingModule,
    EffectsModule.forFeature([PublicWifiEffects]),
    FormsModule,
    LoadingSpinnerModule,
    AlertModule,
    SharedModule,
  ],
  providers: [AuB2B2EOnlyGuard, PublicWifiService, PublicWifiAccountFilterPipe],
})
export class PublicWifiModule {}
